/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import api from './api';
import { API_ENDPOINTS } from '../api/endpoints';

export const adService = {
  getMyAds: () => api.get(API_ENDPOINTS.ME.ADS),
  createAd: (data: any) => api.post(API_ENDPOINTS.ADS.CREATE, data),
};
